import React from 'react'
// import useFormatCurrency from "../../../../../yoello-lib/modules/localisation/useCurrency";
export default function PricingWidget({key,price}:{key:string,price:number}) {
  // const {formatCurrency}=useFormatCurrency();
  return (
    <span key={`${key}-date`}>{price}</span>
  )
}
